export default __webpack_public_path__ + "static/media/phone_light.d02af5c1.png";